import { cn } from "../../../utils/classnames";
import CountryCodePicker from "../../input/input-register/CountryCodePicker";

/**
 * Phone number field for admin forms: the same country dial-code picker as the
 * front pages (searchable, keyboard friendly, animated) + the number input,
 * drawn as one box the height of an <AdminInput>.
 *
 * onCountrySelect(dialCode, countryCode, countryName) — fired when the admin
 * picks a country in the picker.
 */
const AdminPhoneNumberInput = ({
    name = "phoneNumber",
    placeholder = "Phone No.",
    value,
    onChange,
    countryCode,
    dialCode,
    onCountrySelect,
    disabled = false,
    isInvalid = false,
    invalidMessage = "",
    mb = "mb-3",
}) => (
    <div className={mb}>
        <div
            className={cn(
                "tw:flex tw:h-[50px] tw:items-stretch tw:rounded tw:border tw:bg-white tw:transition-[border-color,box-shadow] tw:duration-200",
                "tw:focus-within:border-[#DBBE78] tw:focus-within:shadow-[0_0_0_3px_rgba(219,190,120,0.18)]",
                isInvalid ? "tw:border-[#E5484D]" : "tw:border-[#DEE2E6]"
            )}
        >
            <CountryCodePicker
                countryCode={countryCode}
                dialCode={dialCode}
                onSelect={onCountrySelect}
                disabled={disabled}
                lng="en"
            />
            <input
                type="text"
                name={name}
                value={value ?? ""}
                placeholder={placeholder}
                disabled={disabled}
                onChange={onChange}
                autoComplete="tel-national"
                inputMode="tel"
                className="tw:min-w-0 tw:flex-1 tw:rounded-r tw:border-0 tw:bg-transparent tw:px-3 tw:!text-[15px] tw:font-['Hanken_Grotesk'] tw:text-black tw:outline-none tw:placeholder:!text-[15px] tw:disabled:bg-[#F9F9F9]"
            />
        </div>
        {isInvalid && invalidMessage && <p className="text-danger tw:!mb-0 tw:!mt-1">{invalidMessage}</p>}
    </div>
);

export default AdminPhoneNumberInput;
